import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Sparkles, ArrowRight } from 'lucide-react';
const transformations = [{
  learn: 'A identificar y desarraigar creencias limitantes desde la raíz',
  result: 'Dejarás de sabotearte justo cuando más lo necesitas'
}, {
  learn: 'El Método del Jardín Subconsciente™ paso a paso',
  result: 'Tu mente se convertirá en terreno fértil para la abundancia'
}, {
  learn: 'Cómo reprogramar tus emociones más profundas',
  result: 'Reemplazarás el miedo y la duda por claridad y poder interno'
}, {
  learn: 'Las leyes universales de la manifestación aplicadas',
  result: 'Comprenderás cómo atraer lo que deseas de forma consciente'
}, {
  learn: 'Cómo diseñar la vida que realmente anhelas',
  result: 'Dejarás de sobrevivir y comenzarás a vivir con propósito real'
}, {
  learn: 'Técnicas de neuroplasticidad explicadas con sencillez',
  result: 'Reprogramarás años de patrones limitantes en semanas de práctica'
}];
export function TransformationGrid() {
  return <section className="py-20 px-4 bg-brand-bgAlt" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-282">
          <h2 className="text-3xl md:text-5xl font-bold flex items-center justify-center gap-3" data-id="element-283">
            <Sparkles className="text-brand-gold w-8 h-8" data-id="element-284" />
            ¿Qué Va a Cambiar en Tu Vida?
          </h2>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-lg border border-brand-rose/10 overflow-hidden mb-16" data-id="element-285">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-brand-plum text-brand-bg p-6" data-id="element-286">
            <div className="font-serif text-2xl font-bold flex items-center gap-2 mb-4 md:mb-0" data-id="element-287">
              <span className="text-3xl" data-id="element-288">🌟</span> Aprenderás
            </div>
            <div className="font-serif text-2xl font-bold flex items-center gap-2" data-id="element-289">
              <span className="text-3xl" data-id="element-290">🎯</span> Y en tu vida ocurrirá
            </div>
          </div>

          <div className="divide-y divide-brand-rose/10" data-id="element-291">
            {transformations.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            backgroundColor: '#ffffff'
          }} whileInView={{
            opacity: 1
          }} whileHover={{
            backgroundColor: '#FBF7F1'
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="grid grid-cols-1 md:grid-cols-2 p-6 gap-4 md:gap-8 items-center transition-colors duration-300" data-id="element-292">
                <div className="text-brand-textLight text-lg md:text-xl pr-4" data-id="element-293">
                  {item.learn}
                </div>
                <div className="flex items-start gap-3 text-brand-plum font-medium text-lg md:text-xl" data-id="element-294">
                  <ArrowRight className="w-6 h-6 text-brand-rose shrink-0 mt-1 hidden md:block" data-id="element-295" />
                  <span className="md:hidden text-brand-rose font-bold" data-id="element-296">→</span>
                  {item.result}
                </div>
              </motion.div>)}
          </div>
        </div>

        <CTAButton text="¡SÍ, QUIERO TRANSFORMAR MI VIDA AHORA!" data-id="element-297" />
        <p className="text-center mt-4 text-brand-textLight font-medium" data-id="element-298">
          Acceso inmediato en tu correo electrónico
        </p>
      </div>
    </section>;
}